import React, { useEffect } from 'react';
import { Box, Typography, Button, CircularProgress } from '@mui/material'; // Removed Avatar
import { WorkerListCard, WorkerItem, StatusBadge, ManageButton } from './style';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from 'store';
import { fetchFacilityAssignedWorkers } from 'modules/facility/actions';
import { selectFacilityAssignedWorkers, selectFacilityAssignedWorkersLoading } from 'modules/facility/selectors';
import { IFacilityAssignedWorker } from 'modules/facility/types';
import { useNavigate } from 'react-router-dom';
import SecureAvatar from 'components/common/SecureAvatar';

const AssignedWorkers: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const workers: IFacilityAssignedWorker[] = useSelector(selectFacilityAssignedWorkers);
  const loading: boolean = useSelector(selectFacilityAssignedWorkersLoading);

  useEffect(() => {
    dispatch(fetchFacilityAssignedWorkers());
  }, [dispatch]);

  const getStatusColor = (status: string) => {
    switch (status.toLowerCase()) {
      case 'on time':
        return 'active'; // Greenish
      case 'no show':
        return 'noshow'; // Reddish
      case 'upcoming':
        return 'upcoming'; // Blueish
      default:
        return 'active';
    }
  };

  return (
    <WorkerListCard>
      <Typography variant="h5" sx={{ fontWeight: 600, mb: 3 }}>Assigned Workers</Typography>

      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
          <CircularProgress size={24} />
        </Box>
      ) : workers && workers.length > 0 ? (
        workers.map(worker => (
          <WorkerItem key={`${worker.assignment_id}-${worker.worker_id}`}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <SecureAvatar
                src={worker.profile_picture || undefined}
                alt={worker.name}
                sx={{ width: 52, height: 52, borderRadius: '12px' }}
                variant="rounded"
              >
                {!worker.profile_picture && worker.name.charAt(0)}
              </SecureAvatar>
              <Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Typography variant="body1" sx={{ fontWeight: 600, fontSize: '1.05rem', color: '#333' }}>{worker.name}</Typography>
                  <StatusBadge status={getStatusColor(worker.status)}>{worker.status}</StatusBadge>
                </Box>
                <Typography variant="body2" color="textSecondary" sx={{ mt: 0.5, fontSize: '0.9rem' }}>
                  {worker.role} <span style={{ margin: '0 4px' }}>•</span> Shift: {worker.shift_time}
                </Typography>
              </Box>
            </Box>
            {/* Logic for Cancel Button: Show if needed. For now based on status or logic. 
                Assuming 'Upcoming' or similar might allow cancel. 
                Original mock had explicit 'showCancel' boolean. 
                We can infer from status if needed, or omit if not in API data yet. 
                API data: "status": "On Time" etc. 
                Let's omit for now unless we have a specific rule, or show for upcoming/assigned. 
            */}
            {/* 
            {worker.status === 'Upcoming' && (
               <Button ... >Cancel Shift</Button>
            )}
            */}
          </WorkerItem>
        ))
      ) : (
        <Box sx={{ textAlign: 'center', py: 4, color: 'text.secondary' }}>
          <Typography variant="body2">No workers assigned for today.</Typography>
        </Box>
      )}

      <ManageButton>
        <Button
          variant="contained"
          disableElevation
          sx={{
            bgcolor: '#e8f5e9',
            color: '#2e7d32',
            '&:hover': { bgcolor: '#c8e6c9' },
            textTransform: 'none',
            fontWeight: 600
          }}
          onClick={() => navigate('/facility/shifts')}
        >
          Manage Shifts
        </Button>
      </ManageButton>
    </WorkerListCard>
  );
};

export default AssignedWorkers;
